import React, { useEffect, useState } from 'react';
import { Calendar, Card, notification, Tooltip } from 'antd';
import moment from 'moment';
import { useDailyJournalbydateMutation, useSmallcalendarMutation } from '../../slices/zerodhaApiSlice';
import { setSmallCalendar } from '../../slices/smallcalendarSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setDailyjournal } from '../../slices/dailyjournalSlice';
import "../../screens/css/Calendar.css"
const SmallCalendar = (props) => {
  const { setData, setTotalRecords } = props;
  const [api, contextHolder] = notification.useNotification();
  const { smallcalendar } = useSelector((state) => state.smallcalendar);
  const { date } = useSelector((state) => state.date);
  const [selectedDate, setSelectedDate] = useState(null);
  const [hoveredDate, setHoveredDate] = useState(null);
  const [successDates, setSuccessDates] = useState([]);
  const [dangerDates, setDangerDates] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  var datet = new Date(date ? date.startDate : "");
  const [currentMonth, setCurrentMonth] = useState({ month: datet.getMonth(), year: datet.getFullYear() });
  const [smallCalendar, { isLoading: isCalendarLoading }] = useSmallcalendarMutation();
  const [dailJournalbydate] = useDailyJournalbydateMutation();
  const dispatch = useDispatch();

  const getSmallCalendar = async () => {
    try {
      const res = await smallCalendar().unwrap();
      dispatch(setSmallCalendar({ ...res }));
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };
  // const getDailyJournalbydate = async (date) => {
  //   console.log("date..",date);


  //   try{
  //     const res = await dailJournalbydate({ date
  //             }).unwrap();
  //     dispatch(setDailyjournal({ ...res }));
  //     setTotalRecords(res.data.totalPages)
  //   }catch (err){
  //     api.error({
  //       message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
  //     });
  //   }
  // }
  const getDailyJournalbydate = async (date) => {
    try {
      const res = await dailJournalbydate({ date }).unwrap();



      dispatch(setDailyjournal(res.data));


      // ✅ check if no trades
      if (!res.data?.results || res.data.results.length === 0) {
        api.warning({
          message: "No Trades Found",
          description: "There are no trades available for the selected date.",
        });
      }
    } catch (err) {
      console.error("DailyJournal error:", err);
    }
  };

  useEffect(() => {
    getSmallCalendar();
  }, []);

  useEffect(() => {
    if (smallcalendar) {
      setSuccessDates(smallcalendar.data.successDates || []);
      setDangerDates(smallcalendar.data.dangerDates || []);
      setDataLoaded(true);

    }
  }, [smallcalendar]);

  const handleClick = (date) => {
    setSelectedDate(date);
    getDailyJournalbydate(date.format('YYYY-MM-DD'));
  };

  const firstDateOfMonth = (year, month) => {
    let nmonth = month + 1;
    var firstDayOfMonth = new Date(year, nmonth - 1, 1);
    return firstDayOfMonth;
  }
  const lastDateOfMonth = (year, month) => {
    let nmonth = month + 1;
    var lastDayOfMonth = new Date(year, nmonth, 0);
    return lastDayOfMonth;
  }

  const onPanelChange = (value) => {
    setCurrentMonth({ month: value.$M, year: value.$y }); // Update current month when the panel changes
  };


  const cellRender = (current, info) => {


    if (info.type === 'date') {
      const currentDateStr = current.format('YYYY-MM-DD');
      const currentDateDate = new Date(current.format('YYYY-MM-DD'));

      const firstDate = firstDateOfMonth(currentMonth.year, currentMonth.month);
      const lastDate = lastDateOfMonth(currentMonth.year, currentMonth.month);
      const isToday = current.isSame(moment(), 'day');
      const isActive = selectedDate && current.isSame(selectedDate, 'day');
      const isHovered = hoveredDate && current.isSame(hoveredDate, 'day');
      // const isSuccess = successDates.includes(currentDateStr) && lastDate > currentDateDate && firstDate < currentDateDate;
      // const isDanger = dangerDates.includes(currentDateStr) && lastDate > currentDateDate && firstDate < currentDateDate;

      const isSuccess = successDates.includes(currentDateStr);
      const isDanger = dangerDates.includes(currentDateStr);


      const styles = {
  today: isToday
  ? { border: '2px solid #CB9E52', zIndex: 2 }
  : {},

active: isActive
  ? {
      backgroundColor: '#CB9E52',
      color: '#111111',
      zIndex: 4,
    } 
  : {},
        success: isSuccess ? { backgroundColor: '#d09d4c', color: 'white', zIndex: 1 } : {},
        danger: isDanger ? { backgroundColor: '#8e9196', color: 'white', zIndex: 1 } : {},
        hover: isHovered ? { backgroundColor: '#ffffff', zIndex: 1 } : {},
      };
      

      const combinedStyle = {
        ...styles.today,
        ...styles.active,
        ...styles.success,
        ...styles.danger,
        ...styles.hover,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, border 0.3s ease',
        width: '100%',
        height: '100%',
      };

      return (
        <Tooltip title={`Date: ${current.format('YYYY-MM-DD')}`}>
          <div
            style={combinedStyle}
            onClick={() => handleClick(current)}
            onMouseOver={() => setHoveredDate(current)}
            onMouseOut={() => setHoveredDate(null)}
          >
            {current.date()}
          </div>
        </Tooltip>
      );
    }

    return info.originNode;
  };

return (
  <div className="glass-scope small-calendar">
    {contextHolder}

    <Card
      className="small-calendar__card"
      loading={isCalendarLoading || !dataLoaded}
    >
      {dataLoaded && (
        <Calendar
          className="small-calendar__widget"
          fullscreen={false}
          fullCellRender={cellRender}
          onPanelChange={onPanelChange}
        />
      )}
    </Card>
  </div>
);
};

export default SmallCalendar;